import React from 'react';

interface PropertySheetFooterProps {
  propertyCode: string;
  footerBrandText?: string;
  pageNumber?: number;
  totalPages?: number;
}

export const PropertySheetFooter: React.FC<PropertySheetFooterProps> = ({
  propertyCode,
  footerBrandText,
  pageNumber = 1,
  totalPages = 1,
}) => {
  return (
    <footer className="w-full mt-6 pt-3 border-t border-slate-200/90 text-slate-500">
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-2">
        {/* Left Legal & Identification */}
        <div className="min-w-0">
          <div className="text-[10px] font-extrabold text-slate-700 uppercase tracking-wide leading-normal">
            CÓDIGO DE INMUEBLE: <span className="font-mono text-[#0a2540]">{propertyCode}</span>
            {footerBrandText && (
              <>
                <span className="mx-1.5 text-slate-300">|</span>
                <span className="text-[#0a2540]">{footerBrandText}</span>
              </>
            )}
          </div>
          <p className="text-[9px] text-slate-400 leading-normal mt-0.5 max-w-2xl">
            Documento informativo generado para fines comerciales. Las áreas, medidas y especificaciones técnicas
            son aproximadas y deben ser verificadas en los títulos de propiedad.
          </p>
        </div>

        {/* Right Pagination with Gold Accent Dot */}
        <div className="flex items-center gap-1.5 text-[10px] font-bold text-slate-500 flex-shrink-0 self-end sm:self-center leading-normal">
          <span>
            Página {pageNumber} de {totalPages}
          </span>
          <span className="w-2 h-2 rounded-full bg-[#f59e0b] inline-block" />
        </div>
      </div>
    </footer>
  );
};
